var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar-nav-icon',{staticClass:"d-sm-none",on:{"click":function($event){$event.stopPropagation();_vm.controls.drawer = !_vm.controls.drawer}}})}
var staticRenderFns = []

export { render, staticRenderFns }